import { useRef, useState } from 'react';
import { ReactComponent as InboxSvg } from '../../assets/svg/inbox.svg';
import { ReactComponent as ChevronDownSvg } from '../../assets/svg/chevron-down.svg';
import MessageItem from './messageItem';
import CreateMessageDialog from './createMessageDialog';

const Message = ({ message, user, getMessage }) => {
  const dialogRef = useRef(null);

  const [seeReplies, setSeeReplies] = useState(null);

  const openDialog = () => {
    if (dialogRef.current) {
      dialogRef.current.showModal();
    }
  };

  const closeDialog = () => {
    if (dialogRef.current) {
      dialogRef.current.close();
    }
  };

  return (
    <div>
      <div className='flex justify-end mb-4'>
        <button
          className='border rounded-xl px-2 py-1 text-xs'
          onClick={openDialog}
        >
          new message
        </button>
      </div>
      {message.list?.length > 0 ? (
        <div className='text-sm space-y-6'>
          {message.list.map((msg) => (
            <MessageItem
              key={msg.id}
              item={msg}
              seeReplies={seeReplies}
              setSeeReplies={setSeeReplies}
              user={user}
              getMessage={getMessage}
            />
          ))}
          {message.total.count > message.total.page * message.total.perPage && (
            <div
              className='flex justify-center'
              onClick={async () => getMessage({ next: true })}
            >
              <ChevronDownSvg />
            </div>
          )}
        </div>
      ) : (
        <div className='flex flex-col items-center justify-center gap-4 h-96'>
          <InboxSvg className='size-16 opacity-10' />
          <p className='text-sm opacity-30'>Empty</p>
        </div>
      )}
      <CreateMessageDialog
        dialogRef={dialogRef}
        closeDialog={closeDialog}
        getMessage={getMessage}
        user={user}
      />
    </div>
  );
};

export default Message;
